export const ActionTypes = {
  LOADING: "GET_MS_LOADING",
  ERROR: "GET_MS_ERROR",
  SUCCESS: "GET_MS_SUCCESS",
};
